/**
 * Text tidying shared by the API and the browser.
 *
 * IT LIVES HERE FOR A REASON. The first version of `cleanChunkText` sat in
 * `@esa/core`, and importing that package from a web component pulled
 * `core/rules/load.ts` — and therefore `node:fs/promises` — into the browser
 * bundle. Vite externalises it, the module throws on import, React never
 * mounts, and the entire SPA renders as a blank page. One shared helper in
 * the wrong package took the whole app down.
 *
 * `@esa/shared` is the package both sides may import. Nothing in it may
 * touch the filesystem, the network, or `process`.
 */

/**
 * Strip the chunker's metadata header off a retrieved snippet.
 *
 * The ingest pipeline prefixes each chunk with its own breadcrumbs so the
 * embedding carries context:
 *
 *   [Title: Nominate someone for an ESA Inspo award]
 *   [Path: Symptom > Steps]
 *   Open the nomination form and...
 *
 * Useful to the retriever, noise to a reader — and actively wrong in a reply
 * to a requester, who otherwise gets sent a line of square brackets about a
 * "Path". The header is a run of bracketed `Key: value` lines at the start,
 * so it is removed as such rather than by matching the specific keys this
 * indexer happens to emit today.
 */
export function cleanChunkText(text: string): string {
  const nl = String.fromCharCode(10);
  const lines = text.split(nl);
  let i = 0;
  while (i < lines.length) {
    const line = lines[i]!.trim();
    if (line === '') {
      i += 1;
      continue;
    }
    if (/^\[[A-Za-z][\w .-]{0,40}:[^\]]*\]$/.test(line)) {
      i += 1;
      continue;
    }
    break;
  }
  return lines
    .slice(i)
    .join(nl)
    .replace(new RegExp(`${nl}{3,}`, 'g'), nl + nl)
    .trim();
}
